import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { selectionMachine } from './selection.machine';
export const useSelectionRef = () => feature('selection');
export const useSelection = <R>(selector: (snapshot: SnapshotFrom<typeof selectionMachine>) => R) =>
  useFeature('selection', selector);
